import { useEffect } from 'react';

export default function LoadGTM({ gtmId }) {
  useEffect(() => {
    if (!gtmId || window.__gtmLoaded) return;

    // Create dataLayer and inject script
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    // Optional: add <noscript> iframe for very old/no-JS scenarios
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    iframe.setAttribute('data-gtm-noscript', 'true');
    document.body.appendChild(iframe);

    window.__gtmLoaded = true;

    return () => {
      // Typically you don’t unload GTM, but if you hot-reload/dev:
      const ns = document.querySelector('iframe[data-gtm-noscript="true"]');
      if (ns) ns.remove();
    };
  }, [gtmId]);

  return null;
}
